module.exports = __webpack_public_path__ + "static/media/Bubbly_ios_6.606e8c6e.jpg";